import Event from '@oppobrowser/lib-browser-event';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import template from './index.dot';
import './index.scss';
import { getHeaderKKUA, getSession } from '@js/native';
import { getDocId } from '@js/utils-feeds';
import wv from '@cpc/lib-browser-jsapi';

const EventHandler = {
  clickRelatedreadingStat(node, event) {
    event.stopPropagation();
  },
};

export default class RelatedReading {
  constructor(el) {
    this.el = el;
    this._eventHandler = {};
    this._data = {};
  }
  init() {
    this.initNormal();
  }
  initNormal() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
  }
  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  async initNews() {
    // 获取header头数据
    const kkua = await getHeaderKKUA();
    // 获取session
    const session = await getSession();
    // 调用客户端方法获取feedssession
    const { loginSession } = window.store;

    window.libJsRequire.scriptOnReady({
      url: window.pageData.iflowSdkUrl,
      namespace: 'newsInject',

      callback: function () {
        window.newsInject({
          id: 'reading-news', // 插入容器 #app
          env: window.pageData.newsUrl.env, // 信息流接口环境, 正式环境传pro
          params: {
            channelShortName: 'tuijian',
            type: 'rec',
            feedssession: loginSession,
            session: session,
            flowScene: 'detailPageFeeds_browser',
            count: 8,
            userPath: 'articlePage',
          },
          header: {
            ...kkua, // 必传，获取顺序 优先X-KKBrowser-UA-V3,其次X-KKBrowser-UA-V2, X-KKBrowser-UA 传其中一个即可
          },
          banLoadMore: true,
          style: {
            noPadding: true,
          },
          pageId: 'detailPageFeeds', // 页面标识(也可以通过页面的url配置,具体看c、页面链接增加参数) 新业务接入需要sdk适配 https://doc.myoas.com/pages/viewpage.action?pageId=472175477
          browserPartner: 'browser', // 合作伙伴标识(也可以通过页面的url配置) 新业务接入需要sdk适配 https://doc.myoas.com/pages/viewpage.action?pageId=472175477
        });
      },
    });

    // 信息流点击后回调埋点上报
    window.iFlowItemClick = (article) => {
      // article 点击的数据
      let _data = this.getDataResult(article);
      wv.generalStat('20083211', '10012', '21059', JSON.stringify(_data));
    };

    // 信息流数据曝光后回调
    window.iFlowShowArticles = (articles) => {
      // articles 曝光数据的数组
      articles.forEach((item) => {
        this.getData(item);
      });
    };

    // 本次请求的结果回调 status:1请求成功 2请求错误 错误后会有data返回,data.ret错误码 data.msg错误信息 {status: 1, data:{} }
    window.iFlowApiRequest = (res) => {
      let _dataRes = {
        result: res.status == 1 ? true : false,
        reason: res.status == 1 ? '' : `'${res.data.ret}/${res.data.msg}'`,
      };
      wv.generalStat('20084231', '10012', '21059', JSON.stringify(_dataRes));
    };
  }
  // 获取内容曝光后上报埋点
  getData(articles) {
    this._data = this.getDataResult(articles);
    wv.generalStat('20083212', '10012', '21059', JSON.stringify(this._data));
  }
  // 获取列表内容 点击/曝光 时上报的_data数据
  getDataResult(data) {
    // 配置信息 里面有 source,fromId,,channelId,channelName,
    const newsConfig = window.__newsConfig__;
    let style = '';
    if (data.styleType === 0) {
      style = 3;
    } else if (data.styleType === 1) {
      style = 2;
    } else if (data.styleType === 2) {
      style = 4;
    } else if (data.styleType === 3) {
      style = 1;
    } else if (data.styleType === 28) {
      style = 5;
    } else if (data.styleType === 5) {
      style = 6;
    }
    return {
      style,
      openSource: 'detailPageFeed',
      fromId: (newsConfig && newsConfig.fromId) || '',
      title: data.title,
      docId: data.outId || data.docId,
      sourceDocId: getDocId(),
      type: this.getType(data.styleType),
      position: data.__index__,
      stat_id: data.statisticsid,
      url: data.url,
    };
  }
  // 获取文章类型type
  getType(styleType) {
    let type = '';
    switch (+styleType) {
      case 1:
      case 2:
        type = 'article';
        break;
      case 5:
      case 28:
        type = 'video';
        break;
      case 10:
      case 133:
        type = 'hotList';
        break;
      case 20:
      case 39:
      case 45:
      case 21:
      case 40:
      case 22:
      case 42:
      case 44:
      case 23:
      case 24:
      case 41:
      case 43:
      case 25:
      case 49:
        type = 'ad';
        break;
      case 71:
        type = 'smallVideoDualCard';
        break;
      default:
        type = 'other';
        break;
    }
    return type;
  }
  //夜间模式监听
  registerNightModeHandler() {
    this._nightModeHandler();
    window.document.addEventListener('nightmodechange', () => {
      this._nightModeHandler();
    });
  }
  _nightModeHandler() {
    let relatedReading = document.querySelector('.relatedReading');
    if (window.store.nightMode) {
      relatedReading.classList.add('border-dark');
    } else {
      relatedReading.classList.remove('border-dark');
    }
  }

  render() {
    this.el.innerHTML = template({});
    this.initNews();
    EventEmit.instance.emit('component-loaded', 'relatedReading', {});
    this.registerNightModeHandler();
  }
}
